import React from 'react';

const Intro = () => {
  return (
    <section className="bg-white py-16 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8 md:gap-16">
          
          <div className="w-full md:w-5/12">
            <h2 className="text-3xl md:text-4xl font-extrabold text-black leading-tight tracking-tight">
              Born in India, <br />
              making waves across <br />
              the world
            </h2>
          </div>

          <div className="w-full md:w-7/12">
            <p className="text-gray-600 text-lg leading-relaxed text-justify">
              <span className="font-bold text-gray-800">BNM Wipers</span> stands for innovation and setting new trends in the automotive safety industry. 
              Bringing newer wiping technologies and continuous innovation in existing as well as new products has been the focal point at BNM. 
              This special emphasis helps the brand set the bar higher and lead amongst others by example.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};
export default Intro;